import { createAction, props } from '@ngrx/store';
import { Voucher } from 'src/app/interfaces/voucher';

export const retrieve = createAction('[Voucher] Retrieve');
export const retrieveSuccess = createAction('[Voucher] Retrieve Success', props<{ vouchers: Voucher[] }>());
export const retrieveFailure = createAction('[Voucher] Retrieve Failure', props<{ error: string }>());
